import React from 'react';
import { Card, CardContent, Grid, Typography, Button, Paper, Box } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import Reproductor from './Reproductor';

export const Cursos = () => {
  const videoUrl =
    'https://easycreditvideos.nyc3.cdn.digitaloceanspaces.com/AJUSTES%20DE%20HOJA%20DE%20CALCULO%20Y%20FORMATO%20DE%20DATOS.mp4';

  const videoUrl2 = 'https://easycreditvideos.nyc3.cdn.digitaloceanspaces.com/GRAFICAS,OPERACIONES,MULTIPLES.mp4';
  const videoUrl3 =
    'https://easycreditvideos.nyc3.cdn.digitaloceanspaces.com/AJUSTES%20DE%20HOJA%20DE%20CALCULO%20Y%20FORMATO%20DE%20DATOS.mp4';
  const videoUrl4 = 'https://easycreditvideos.nyc3.cdn.digitaloceanspaces.com/FUNCIONES%20Y%20SEGURIDAD.mp4';
  
  const handleDownloadTemplate = () => {
    // La ruta al archivo debe ser relativa a la carpeta public
    const fileUrl = '/downloads/plantilla_financiera.xlsx';
    
    // Crear un elemento <a> para la descarga
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', 'plantilla_financiera.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  return (
    <Card>
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          Capacitación: Crece con Easy Credit
        </Typography>
        <Typography variant="body2" color="text.secondary">
          En Easy Credit estamos comprometidos con tu crecimiento, tanto financiero como educativo. Por eso, te
          ofrecemos estos cursos de capacitación financiera, diseñados para brindarte las herramientas y el conocimiento
          necesario para manejar tus finanzas de manera efectiva y alcanzar tus metas. Nos enorgullece ser parte de tu
          camino hacia un futuro más seguro y próspero.
        </Typography>
        
        <Grid container justifyContent="center" alignItems="center" spacing={2} style={{ marginTop: '20px' }}>
          <Grid item xs={12}>
            <div style={{ padding: '20px' }}>
              <Reproductor videoUrl={videoUrl} titulo={'Ajuste a la hoja de Cálculo.'} />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={{ padding: '20px' }}>
              <Reproductor videoUrl={videoUrl2} titulo={'Gráficas y operaciones multiples.'} />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={{ padding: '20px' }}>
              <Reproductor videoUrl={videoUrl3} titulo={'Ajuste de hojas de calculo y formatos.'} />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div style={{ padding: '20px' }}>
              <Reproductor videoUrl={videoUrl4} titulo={'Funciones y Seguridad.'} />
            </div>
          </Grid>
        </Grid>
        
        <Paper elevation={3} style={{ padding: '25px', marginTop: '30px', backgroundColor: '#f8f9fa' }}>
          <Typography variant="h6" gutterBottom color="primary">
            Optimiza tu Gestión Financiera Personal
          </Typography>
          <Typography variant="body1" paragraph>
            El control sistemático de tus finanzas es el primer paso hacia la estabilidad económica y la construcción de un futuro financiero sólido. 
            Nuestra plantilla especializada ha sido diseñada por expertos financieros para ayudarte a:
          </Typography>
          <Box sx={{ pl: 2, mb: 2 }}>
            <Typography variant="body1" paragraph>
              • Visualizar claramente tus ingresos y gastos mensuales
            </Typography>
            <Typography variant="body1" paragraph>
              • Identificar oportunidades de ahorro y optimización de recursos
            </Typography>
            <Typography variant="body1" paragraph>
              • Establecer y monitorear objetivos financieros realistas
            </Typography>
            <Typography variant="body1" paragraph>
              • Tomar decisiones informadas basadas en datos concretos
            </Typography>
          </Box>
          <Typography variant="body1" paragraph>
            Esta herramienta complementa perfectamente la formación que recibes en nuestros cursos, permitiéndote aplicar
            de manera práctica los conocimientos adquiridos.
          </Typography>
          
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              startIcon={<DownloadIcon />}
              onClick={handleDownloadTemplate}
            >
              Descargar Plantilla de Control Financiero
            </Button>
          </Box>
        </Paper>
      </CardContent>
    </Card>
  );
};
